<div class="editor-shell" *ngIf="!loading; else loadingTpl">

	<!-- ── Top bar ── -->
	<div class="editor-toolbar">
		<span class="dashboard-name">{{ dashboard?.name }}</span>

		<!-- Breakpoint switcher -->
		<nz-space-compact>
			<button nz-button *ngFor="let bp of breakpoints" [nzType]="activeBreakpoint === bp ? 'primary' : 'default'"
				(click)="switchBreakpoint(bp)">
				{{ bp }}
			</button>
		</nz-space-compact>

		<button nz-button nzType="primary" [nzLoading]="saving" (click)="save()">
			<span nz-icon nzType="save"></span> Save
		</button>
	</div>

	<!-- ── Palette ── -->
	<div class="palette">
		<span class="palette-label">Available Components</span>
		<div class="palette-chips">
			<div class="palette-chip" *ngFor="let comp of palette" (click)="addToGrid(comp)">
				<span nz-icon nzType="plus-circle"></span>
				{{ comp.name }}
				<span class="chip-type">{{ comp.componentType }}</span>
			</div>
			<div class="palette-empty" *ngIf="palette.length === 0">
				All components placed
			</div>
		</div>
	</div>

	<!-- ── Grid canvas ── -->
	<div class="grid-canvas">
		<gridster [options]="options">
			<gridster-item *ngFor="let placement of activePlacements" [item]="placement.item">
				<div class="grid-cell">
					<div class="grid-cell-header">
						<span class="grid-cell-name">{{ placement.component.name }}</span>
						<span class="grid-cell-type">{{ placement.component.componentType }}</span>
						<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeFromGrid(placement)">
							<span nz-icon nzType="delete"></span>
						</button>
					</div>
					<div class="grid-cell-coords">
						<ng-container [ngSwitch]="placement.component.componentType">
							<app-dashboard-chart-bar     *ngSwitchCase="'BarChart'"></app-dashboard-chart-bar>
							<app-dashboard-chart-line    *ngSwitchCase="'LineChart'"></app-dashboard-chart-line>
							<app-dashboard-chart-pie     *ngSwitchCase="'PieChart'"></app-dashboard-chart-pie>
							<app-dashboard-chart-gauge   *ngSwitchCase="'GaugeChart'"></app-dashboard-chart-gauge>
							<app-dashboard-chart-scatter *ngSwitchCase="'ScatterChart'"></app-dashboard-chart-scatter>
							<app-dashboard-table 		 *ngSwitchCase="'Table'"></app-dashboard-table>
							<ng-container *ngSwitchDefault>
								<span>Unsupported component type: {{placement.component.componentType}}</span>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</gridster-item>
		</gridster>
	</div>

</div>

<ng-template #loadingTpl>
	<nz-spin nzTip="Loading dashboard..."></nz-spin>
</ng-template>
